import formUtils from 'shared/src/formUtils'
import TextField from './Text'
import TextAreaField from './TextArea'
import RadioField from './Radio'
import CheckboxField from './Checkbox'
import MultipleCheckboxField from './MultipleCheckbox'
import SelectField from './Select'
import ColorField from './Color'
import ImageField from './Image'
import ListField from './List'
import NotesField from './Notes'
import DateField from './Date'
import TimeField from './Time'
import PriceGroupField from './PriceGroup'
import MarkdownField from './Markdown'
import EmbedWidget from './EmbedWidget'

const fields = {
  text: TextField,
  textarea: TextAreaField,
  radio: RadioField,
  checkbox: CheckboxField,
  multipleCheckbox: MultipleCheckboxField,
  select: SelectField,
  color: ColorField,
  image: ImageField,
  list: ListField,
  notes: NotesField,
  date: DateField,
  time: TimeField,
  pricegroup: PriceGroupField,
  markdown: MarkdownField,
  embedWidget: EmbedWidget,
}

export const defaultValues = formUtils.defaultValues


export default fields